import React from "react";
import { Form, Input, InputNumber, Popover, Row, theme } from "antd";
import { URL_POND } from "../../constants/urls";
import { POST } from "../../frameworks/HttpClient";
import ColorButton from "../../common/ColorButton";

export default function PondWeightPopover(props){
  const { target, onUpdate, children, title} = props;
  const [form] = Form.useForm(); 
  const [visible, setVisible] = React.useState(false);
  const weightWatch = Form.useWatch('weight', form)
  const inputRef = React.useRef(null);
  // ฟังก์ชันเปิด/ปิด Popover
  const handleVisibleChange = (newVisible) => {
    setVisible(newVisible);
    form.resetFields();
  };


  const handleOK = async() => {
    try {
      const data = await form.validateFields();
      data["pond_transaction"] = target.current_transaction;
      await POST(URL_POND.POND_TRANSACTION_WEIGHT_LOG, data);
      onUpdate();
      setVisible(false); 
    } catch (error) {
      if(error){
        console.log(error.errorMessages); 
      }
    }
  }

  const handlePressEnter = () => {
    // โฟกัสไปยัง Input ตัวที่ 2
    if (inputRef.current) {
      inputRef.current.focus();
    }
  };

  const { token : { colorWarning }} = theme.useToken();

  React.useEffect(() => {
      form.resetFields();
  },[target])

  return (
    <Popover 
      title={<center>{title}</center>}
      trigger="click"
      open={visible}
      onOpenChange={handleVisibleChange}
      content={ 
        <Form
          form={form}
          style={{ width: "100%"}}
          autoComplete="off"
          layout="vertical"  
        >
            <Row>
            <Form.Item
              name={"height"}
              style={{ alignItems: 'center',  justifyContent: 'center', display: 'flex', marginBottom : 5 }}
              rules={[
                {
                  required: true,
                  message: 'กรุณากรอกข้อมูล'
                },
              ]}>
                  <InputNumber 
                    ref={inputRef} 
                    autoComplete="off" 
                    style={{ width: 250 }} 
                    placeholder="ส่วนสูง" 
                    addonBefore="ส่วนสูง" 
                    addonAfter="cm" 
                    onChange={(value) => {
                      if(target.weight_per_height){
                        form.setFieldValue('weight', Math.round(value * target.weight_per_height))
                      }
                    }}
                    // onPressEnter={(e) => !weightWatch ? form.setFieldValue('weight', (e.target.value * target.weight_per_height) ?? 0) : handleOK()} 
                  />
            </Form.Item>
            </Row>

            <Row>
            <Form.Item
              name={"weight"}
              style={{ alignItems: 'center',  justifyContent: 'center', display: 'flex',}}
              rules={[
                {
                  required: true,
                  message: 'กรุณากรอกข้อมูล'
                },
              ]}>
                  <InputNumber autoComplete="off" style={{ width: 250 }} placeholder="น้ำหนัก" addonBefore="น้ำหนัก" addonAfter="Kg" onPressEnter={() => handlePressEnter()} precision={0}/>
            </Form.Item>
            </Row>
            <Row>
              <Form.Item
                name={"note"}
                // label={"หมายเหตุ"}
                style={{ alignItems: 'center',  justifyContent: 'center', display: 'flex'}}
              >
                <Input autoComplete="off" style={{ width: 250 }} placeholder="หมายเหตุ"/>
              </Form.Item>
            </Row>

            <Form.Item>
              <ColorButton type={"primary"} override={colorWarning} onClick={handleOK} style={{ float : 'right'}}>แก้ไข</ColorButton>
              <ColorButton onClick={() => setVisible(false)} style={{ float : 'right', marginRight : 5 }}>ปิด</ColorButton>
            </Form.Item>
        </Form>
      }
    >
      {children}
    </Popover>
  )
}